import { getChannelIcon, normalizeConnectionChannel } from "../pages/Connections/connectionChannelsCatalog";

/**
 * Resolve badge do canal (WhatsApp, e-mail, etc.) para overlay no avatar.
 * @returns {{ kind: "email" } | { kind: "img", src: string } | null}
 */
export function resolveChannelBadge(channel, contactChannel) {
	const ch = normalizeConnectionChannel(channel || contactChannel || "");

	if (!ch) return null;
	if (ch === "email") return { kind: "email" };

	const src = getChannelIcon(ch);
	if (!src) return null;

	return { kind: "img", src };
}
